// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'webcam-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinejoin='round'>
    <g strokeLinecap='round'>
      <path d='M13.468 13.203c-.75 1.11.313 3.235 1.376 3.766H3.156c1.063-.531 2.125-2.656 1.376-3.766' />
      <path
        fill='currentColor'
        d='M9 .531a7.406 7.406 0 1 1 0 14.813A7.406 7.406 0 0 1 9 .53zM9 4.25a3.688 3.688 0 1 0 0 7.375A3.688 3.688 0 0 0 9 4.25z'
      />
    </g>
    <path d='M9 8.203a.266.266 0 1 1 0-.531m0 .531a.266.266 0 1 0 0-.531' />
  </g>
);

export const viewBox = '0 0 18 18';
